export default __webpack_public_path__ + "static/media/final-step-bg.442e238f.webp";